



















import {Component, Mixins} from 'vue-property-decorator'
import ModalBaseBody from '../ModalBaseBody.vue'
import TravelCriteria from '@/components/filter/TravelCriteria.vue'
import InputCommon from '@/components/lib/InputCommon.vue'
import modalStepMixin from '@/mixins/modalStepMixin'
import {TravelInfoIdsExtended, ITravelInfoIdsExtended} from '@/entities'

@Component({
  components: {
    ModalBaseBody,
    TravelCriteria,
    InputCommon
  }
})
export default class ModalConsultationMessage extends Mixins(modalStepMixin) {

  private criteria: ITravelInfoIdsExtended = new TravelInfoIdsExtended();
  private description: string = '';

  get key(): string | number {
    return this.$store.state.modal?.key;
  }

  protected getHandlers(): { [key: string]: Function } {
    let self = this;
    return {
      next: (function () {
        return new Promise<void>((resolve, reject) => {
          self.$storage.actions.addConsultationInfo({
            key: self.key,
            payload: {
              ...self.criteria,
              description: self.description
            }
          })
            .then(() => {
              self.subject.status = 'ready';
              resolve();
            })
            .catch(reject);
        });
      })
    }
  }

  get criteriaFields(): string[] {
    return Object.keys(this.criteria)
      .map((key: string) => {
        return key
          .replace(/_min$/g, '')
          .replace(/_max$/g, '');
      })
      .filter((k: string, i: number, set: string[]) => (set.indexOf(k) === i));
  }

}
